import FormattedMessage from 'I18n/components/FormattedMessage';
import { AudioInputOutputIcon, CapIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import { H5 } from 'foundations-components/transitional/components/H5';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SupportCluster = ({
  icon,
  title,
  description
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "start",
    children: [/*#__PURE__*/_jsx(IconCircle, {
      size: "850",
      icon: icon,
      backgroundColor: "fill-info-subtle",
      color: "icon-interactive-default",
      borderWidth: "0",
      marginInlineEnd: "600",
      padding: "400"
    }), /*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      align: "start",
      children: [/*#__PURE__*/_jsx(H5, {
        "aria-level": 3,
        marginBlockEnd: "100",
        children: title
      }), /*#__PURE__*/_jsx(View, {
        margin: "0",
        children: description
      })]
    })]
  });
};
export const ProPlusSupportContent = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    marginBlock: "1500",
    children: [/*#__PURE__*/_jsx(H2, {
      "aria-level": 2,
      marginBlockEnd: "1100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgradePages.trialUpgradePage.proPlusSupport.header"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      justifyContent: "space-between",
      gap: "1200",
      children: [/*#__PURE__*/_jsx(SupportCluster, {
        icon: AudioInputOutputIcon,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgradePages.trialUpgradePage.proPlusSupport.liveSupport.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgradePages.trialUpgradePage.proPlusSupport.liveSupport.body"
        })
      }), /*#__PURE__*/_jsx(SupportCluster, {
        icon: CapIcon,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgradePages.trialUpgradePage.proPlusSupport.assistedOnboarding.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgradePages.trialUpgradePage.proPlusSupport.assistedOnboarding.body"
        })
      })]
    })]
  });
};